'use client';

import { useRouter } from 'next/navigation';
import { exitDraftMode } from '@/utils/draft-mode';

import Button from '../ui/button';

export type DraftModeToolbarProps = {
  pathToCMS: string;
};

export const DraftModeToolbar: React.FC<DraftModeToolbarProps> = ({
  pathToCMS,
}) => {
  const router = useRouter();
  return (
    <section className="flex justify-end gap-x-3 bg-gray-100 p-2">
      <div>
        <h3 className="text-lg font-bold text-gray-700">Draft Mode</h3> cache
        disabled
      </div>
      <Button onClick={() => router.push(pathToCMS)}>Edit in CMS</Button>
      <Button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          exitDraftMode().then(() => window.location.reload());
        }}
      >
        Exit CMS Draft Mode
      </Button>
    </section>
  );
};
